import {
  GET_RESULT_SUCCESS,
  SET_RESULT,
  CREATE_RESULT_SUCCESS,
} from 'actionTypes';

const initialState = null;

export default function currentResultReducer(state = initialState, action) {
  const { type, result } = action;
  switch (type) {
    case SET_RESULT:
    case GET_RESULT_SUCCESS:
    case CREATE_RESULT_SUCCESS:
      return result.uuid;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/currentResultReducer.js